import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";

const API_URL = axiosUrl.getAxiosUrl();

class UserStatsService {
  async getGeneralUserStats(locale) {
    return await axios
      .get(API_URL + "/stats/getGeneralUserStats", {
        params: {
          culture: locale.value,
        },
      })
      .then((response) => {
        store.commit(
          "userStats/updateGeneralUsersStatsFrontOffice",
          response.data.userStatsBoxes
        );
      });
  }

  async getUsersTableStats(locale) {
    return await axios
      .get(API_URL + "/stats/getUsersTableStatsFront", {
        params: {
          culture: locale.value,
        },
      })
      .then((response) => {
        store.commit("userStats/updateTableStats", response.data.userStats);
      });
  }

  async getGeneralStatsFront(locale) {
    return await axios
      .get(API_URL + "/stats/getGeneralStatsFront", {
        params: {
          culture: locale.value,
        },
      })
      .then((response) => {
        store.commit("userStats/updateGeneralStatsFront", response.data);
      });
  }

  async getOBData(team) {
    return await axios
      .get(API_URL + "/stats/getOBData", {
        params: {
          department: team && team.value ? team.value : null,
        },
      })
      .then((response) => {
        store.commit("onzeStats/updateOnzeBarData", response.data);
      });
  }

  async getOnzeConsultants(team) {
    return await axios
      .get(API_URL + "/stats/getConsultants", {
        params: {
          team: team,
        },
      })
      .then((response) => {
        store.commit("onzeStats/updateConsultants", response.data);
      });
  }

  async getDepartments() {
    return await axios
      .get(API_URL + "/stats/getDepartments")
      .then((response) => {
        store.commit("onzeStats/updateDepartments", response.data);
      });
  }

  async insertSearchFilterStat(tagId, hasChildren, wasSelectedBefore) {
    return await axios
      .post(API_URL + "/stats/insertSearchFilterStat", {
        tagId: tagId,
        hasChildren: hasChildren,
        wasSelectedBefore: wasSelectedBefore,
      })
      .then(() => {});
  }
}
export default new UserStatsService();
